import React from 'react';
import cx from 'classnames';
import styled from '@emotion/styled';
import Fa from 'components/fa';

const Block = styled(Fa)`
  width: 23px;
  height: 23px;
  line-height: 23px;
  text-align: center;
  background: #e0e0e0;
  font-size: 16px;
  color: #333;
  margin: 0;
`;

const FaBlock = ({ className, ...props }) => (
  <Block
    {...props}
    className={cx(
      'fa-block',
      className?.split(' ').filter(name => name !== 'fa' && name !== 'fa-block'),
    )}
  />
);

export default FaBlock;
